import { Button, Flex } from '@radix-ui/themes';
import { useDeliveryContext } from './DeliveryContext';
import { DeliveryItem } from '../../types';

export interface ActionSubmitProps {
    label: string;
    processingLabel: string;
    disabled?: boolean;
    onClick: () => void;
}

export const ActionSubmit = <T extends DeliveryItem, P>({
    label,
    processingLabel,
    disabled = false,
    onClick,
}: ActionSubmitProps) => {
    const { isProcessing, selectedIds } = useDeliveryContext<T, P>();

    const isButtonDisabled =
        disabled || isProcessing || selectedIds.length === 0;

    return (
        <Flex justify='center' mt='3'>
            <Button
                size='3'
                radius='full'
                disabled={isButtonDisabled}
                onClick={onClick}
                style={{ width: '220px' }}
            >
                {isProcessing ? processingLabel : label}
            </Button>
        </Flex>
    );
};
